export const adminAccessPermissions = [
  'admin:users',
  'admin:prompts',
  'admin:profiles',
  'admin:coaches',
  'admin:cron',
  'admin:rbac',
  'admin:evals',
  'admin:internal-apps',
  'admin:lifecycle.adjust',
];

const rolePermissionOverrides: Record<string, string[]> = {
  super_admin: ['admin:*', 'admin:internal-apps', 'admin:lifecycle.adjust'],
  admin: [
    'admin:users',
    'admin:prompts',
    'admin:profiles',
    'admin:coaches',
    'admin:evals',
    'admin:lifecycle.adjust',
  ],
  coach: ['coach:tools'],
};

const resolvePermissions = (perms: string[], roles: string[]) => {
  const resolved = new Set(perms);
  roles.forEach((role) => {
    const mapped = rolePermissionOverrides[role];
    if (mapped) {
      mapped.forEach((permission) => {
        resolved.add(permission);
      });
    }
  });
  return resolved;
};

export const hasAnyPermission = (perms: string[], required: string[], roles: string[] = []) => {
  const resolved = resolvePermissions(perms, roles);
  return required.some((req) => resolved.has(req) || resolved.has('admin:*'));
};
